import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const LocationsComponent = () => {
  return (
    <>
      <Helmet>
        <title>Location | Admin</title>
      </Helmet>
      <Outlet />
    </>
  );
};

export default LocationsComponent;
